<template>
<div class="investmentClues" >
<leftnav class="fl" mkcode="C" :itemcode="(curWebsite.type == 5 || curWebsite.type == 6)? 'C-QYTZPH':'C-GDXSTJ'"></leftnav> 
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage">
			<!-- 头部盒子开始 -->
			<div class="whitebox right_topbox">
				<div class="right_boxtitle">
					<span class="fl right_title" v-if="curWebsite.type != 5 && curWebsite.type != 6">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</span>
					<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">产业排行榜</span>
					<cluetips></cluetips>  
					<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 -->
			<div class="opport-screen-list1">
			<div class="spage-searchbox "> 
				<ClueNav tabCode="phb"></ClueNav>
				<dl class="opport-screen bdbe" >
					<dt class="fl">排行榜</dt>
					<dd class="fl">
					<span  v-for="(list,i) in dimensionList" :key="i" :class="orderField == list.type?'a-screen current':'a-screen'" @click="tablesort(list.type)">{{list.name}}TOP100</span> 
					</dd>
				</dl>  
			</div> 
		</div>
		<!-- 筛选项结束 -->
		</div>
		<!-- 头部盒子结束 -->  
		<!-- 表格内容开始 -->
		<div class="whitebox"> 
				<!-- 重点区域招商 -->
			<div class="enterprise_list_box" style="padding-top: 20px;">   
			<!-- 龙头  优质 上市 创新通用表格 -->
			<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
					<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>所属产业</th>
						<th>画像标签</th>
						<th>地区</th>
					<!-- 	<th>企业实力</th>
						<th>投资力度</th> -->
						<th v-show="orderField >7 ">投资项目数量</th>
						<th v-show="orderField >7 ">投资项目金额</th>
						<th v-show="orderField <8 ">拿地数量</th>
						<th v-show="orderField <8 ">拿地面积</th>
						<th v-show="orderField <8 ">拿地金额</th>
						<th>编辑</th>
					</tr>
					<tr v-for="(list,index) in enterpristlist" :key="list.title+list.stockCode">
						<td>{{(page-1)*pageSize+index+1}}</td>
						<td class="title" @click="routerlinkid('/enterprises',list.stockCode,9,'',curindex)">
							{{list.title}}</td>
						<td class="conpanytags hastag">
							<span class="span-tag" v-for="item in list.notionlist" :key="item.id"
								@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name,'all')">{{item.name}}</span>
						</td>
						<td class="conpanytags hastag">
							<span class="span-tag" v-for="item in list.taglist" :key="item.id"
								@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'all')">{{item.name}}{{item.count}}</span>
						</td>
						<td>{{list.area}}</td>
					<!-- 	<td>{{list.zs100000}}</td>
						<td>{{list.zs200000}}</td> -->
						<td v-show="orderField >7 " >{{list.projectNum}}</td>
						<td v-show="orderField >7 ">{{list.projectMoney}}{{list.projectMoneyUnit}}</td>
						<td v-show="orderField < 8 " >{{list.landNum}}</td>
						<td v-show="orderField < 8 " >{{list.landSize}}{{list.landSizeUnit}}</td>
						<td v-show="orderField < 8 ">{{list.landMoney}}{{list.landMoneyUnit}}</td>
						<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
					</tr>
				</table>
			</div>
		</div>  
		<!-- 表格内容结束 -->
		<div class="centerpage1 company_pagelist nojump" v-show="totalPage>1">
			<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
				v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
			</zpagenav>
		</div> 
		</div> 
		</div>
	</div>
</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'investmentClues8',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
			data(){return{ 
				title:"排行榜",  
				total1:0,
				userdata:{},curWebsite:this.$api.getWebsiteType(), 
				searchtype:8, //线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业  
				dimensionList: [ {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				},{
					name: '拿地金额',
					type: 7
				},{
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}],   
				enterpristlist:[], 
			
				orderField:5, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
				dimesmlist:[{
					name: '总体评分',
					type: 0
				}, {
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				},],
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 100, //记录总数 
				totalPage:1,
				maxPage:10,  //最大页数  
			}},
			created() { 
				this.$nextTick(() => {
						// 禁用右键
						document.oncontextmenu = new Function("event.returnValue=false");
						// 禁用选择
						document.onselectstart = new Function("event.returnValue=false");
				});
			var _this=this; 
			this.userdata =this.getuserinformain();
		 
			this.getcompanylist();
			},
			mounted() { 
				document.getElementById('app').style.background = "#f0f3f5";
			},
			methods: {
						//获取产业链/区域/融资企业招商线索
						getcompanylist(paged) {
							this.bus.$emit('loading', true);
							// console.log('getcompanylist'); 
							this.page=paged?paged:1;
							var _this = this;
							//获取企业列表
							var notionja = this.splicing('notion', this.notionCode);
							var cityja = this.splicing('city', this.cityid);
							var provja = this.splicing('province', this.proid);
							var ajaxurl = this.$api.cyl.enterprise.list() + '?type=0&page='+this.page+'&pageSize=100' +'&orderField=' + this.orderField + '&orderType=' + this.orderType;
							// console.log(ajaxurl);
							this.$axios.get(ajaxurl, {
								headers: {
									AuthToken: this.userdata.token
								}
							}).then(function(res) {
								// console.log('省份城市列表',res.data)
								var citycountlist = res.data.cityList;
								if (res.data.success) {
								 
									console.log(ajaxurl,'获取热门排行榜企业列表', res.data);
									_this.enterpristlist = res.data.list;
									for (var i = 0; i < res.data.list.length; i++) {
										_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this.enterpristlist[i].tagCode);
										_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode,'notionsort');
									}
						
									_this.totalPage = res.data.totalPage;
									_this.pageSize = res.data.pageSize;
									// _this.total = res.data.totalRecord;
									// _this.haspage = res.data.list.length == res.data.pageSize;
									_this.bus.$emit('loading', false);
								} else {
									
								}
							}).catch(function(error) {
								// 请求失败处理 console.log(error);
							});
						},
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getcompanylist();
			}, 
			// pageHandler: function (page) {
			// 	this.page = page; 
			// 	this.getcompanylist(page); 
			// },
			pageHandler: function(page) { 
				this.getcompanylist(page);  
			},
				jsondouhao(name,data){
					if(data.length>0){ 
						var notionja="";
						if(data.length!=0){
							var douhao='%2C';
							for(var i=0;i<data.length;i++){ 
								if(i==data.length-1){
									douhao='';
								}
								notionja+=data[i].id+douhao;
							}
							notionja='&'+name+'='+notionja;
							return notionja;
						} 
					}else{
						return "";
					}
				},
			},
	}
</script>

<style> 
/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #E0E8F9;
}
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #E0E8F9;
} 
/* 提示框背景色 */
.atooltip {
  background: #E0E8F9 !important; 
}
 
 
	.a-red{
		color:#c00;
	}
	.nojump .jump{display: none;}
</style>
